import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 3.8 8.4 c 0 -0.6 0.4 -1 1 -1 h 14.4 a 1 1 0 1 1 0 2 H 4.8 a 1 1 0 0 1 -1 -1 Z m 0 7.2 c 0 -0.6 0.4 -1 1 -1 h 14.4 a 1 1 0 1 1 0 2 H 4.8 a 1 1 0 0 1 -1 -1 Z"
  />,
  'Equals'
)
